import React from 'react';

import { Row } from 'antd';

import { FavoriteStarIconRender } from 'common/components';
import ProductPackLevel from 'common/components/thumb/product/ProductPackLevel';
import GdsnShieldIcon from 'common/components/thumb/product/GdsnShieldIcon';
import ProductSubscription from 'common/components/thumb/product/ProductSubscription';
import SharedIcon from 'common/components/thumb/share/SharedIcon';
import EditableIcon from 'common/components/thumb/product/EditableIcon';
import { OverlayIcon } from 'common/components/icon-renderer/GridItemIcons';
import IxOneCertifiedIcon from 'common/components/thumb/product/IxOneCertifiedIcon';
import TcpProductIcon from 'common/components/thumb/product/TcpProductIcon';

import { useCheckAllowEditProducts } from 'hooks';

import { checkIsOwner } from 'utils/checkIsOwner';

import 'common/components/thumb/ThumbnailItem.less';

import { useUserInfo } from 'hooks/auth/useUserInfo';

const AgGridIcons = (props) => {
  const {
    isFavorite,
    isShared,
    packageLevel,
    data = {},
    gdsnShield,
    subscriptionShield,
    isProductOverlay,
    isIxOneCertified,
    isTcpProduct,
  } = props;

  const {
    userId,
  } = useUserInfo();

  const { checkAllowEditProductFull } = useCheckAllowEditProducts();

  const { type } = data;

  const renderEditableIcon = () => {
    if (type === 'Product') {
      const showEditableProductIcon = checkAllowEditProductFull(data);

      return showEditableProductIcon ? <EditableIcon /> : null;
    }
  };

  const renderFavoriteIcon = () => {
    return isFavorite ? (
      <div className='ag-grid__favorite-icon'>
        <FavoriteStarIconRender isFavorited={isFavorite} />
      </div>
    ) : null;
  };

  const renderSharedIcon = () => {
    return isShared && !checkIsOwner(data, userId) ? (
      <SharedIcon dataDetail={data} />
    ) : null;
  };

  const renderPackageLevelIcon = () => {
    return packageLevel ? (
      <ProductPackLevel packLevel={packageLevel} id={data?.id} />
    ) : null;
  };

  const renderSubscriptionShieldIcon = () => {
    return subscriptionShield ? (
      <ProductSubscription status={subscriptionShield} gdsnShield={gdsnShield} />
    ) : null;
  };

  const renderGdsnShieldIcon = () => {
    return gdsnShield ? (
      <GdsnShieldIcon
        gdsnShield={gdsnShield}
        subscriptionShield={subscriptionShield}
      />
    ) : null;
  };

  const renderProductOverlayIcon = () => {
    return isProductOverlay ? <OverlayIcon /> : null;
  };

  const renderIxOneCertifiedIcon = () => {
    return isIxOneCertified ? <IxOneCertifiedIcon /> : null;
  };

  const renderTcpProductIcon = () => {
    return isTcpProduct ? <TcpProductIcon /> : null;
  };

  return (
    <Row align='middle' className='ag-grid__icon-list'>
      {renderEditableIcon()}
      {renderFavoriteIcon()}
      {renderSharedIcon()}
      {renderPackageLevelIcon()}
      {renderSubscriptionShieldIcon()}
      {renderGdsnShieldIcon()}
      {renderProductOverlayIcon()}
      {renderIxOneCertifiedIcon()}
      {renderTcpProductIcon()}
    </Row>
  );
};

export default AgGridIcons;
